import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { Button, ButtonToolbar } from 'reactstrap';
import { Link } from 'react-router-dom';
import ModuleList from '../../../layout/ModuleList';
import {
  BUS_ASSIGNMENT_SCHEDULE_PATH,
  NEW_BUS_ASSIGNMENT_SCHEDULE_PATH,
} from '../../../../config/paths';
import {
  clearBusAssignmentSchedules,
  getBusAssignmentSchedules,
  getExportBusAssignmentSchedules,
} from '../../../../actions/bus/BusAssignmentSchedule';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { BUS_ASSIGNMENT_SCHEDULE_COLUMNS } from '../../../../config/columns';

const BusAssignmentSchedules = ({
  breadcrumbs,
  loading,
  dispatchGetBusAssignmentSchedules,
  dispatchClearBusAssignmentSchedules,
  busAssignmentSchedules,
  dispatchGetExportBusAssignmentSchedules
}) => {
  useLayoutEffect(() => () => dispatchClearBusAssignmentSchedules(), []);

  const data = busAssignmentSchedules.get('content') || [];
  const pages = busAssignmentSchedules.get('totalPages') || null;
  const defaultPageSize =
    busAssignmentSchedules.get('size') || DEFAULT_PAGE_SIZE;

  const extraButtons = (
    <>
      <ButtonToolbar>
        <Button className="btn btn-success mr-2" onClick={dispatchGetExportBusAssignmentSchedules}>
          <i className="fa fa-file-excel-o" />{' '}
          Exportar
        </Button>
        <Link to={NEW_BUS_ASSIGNMENT_SCHEDULE_PATH} className="btn btn-primary">
          <i className="fa fa-plus-circle" />{' '}
           Nuevo
        </Link>
      </ButtonToolbar>
    </>
  )

  return (
    <ModuleList
      title="Asignación de Rutas"
      breadcrumbs={breadcrumbs}
      extraButtons={extraButtons}
      tableStructure={{
        columns: BUS_ASSIGNMENT_SCHEDULE_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetBusAssignmentSchedules,
        modelPath: BUS_ASSIGNMENT_SCHEDULE_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

BusAssignmentSchedules.propTypes = {
  breadcrumbs: PropTypes.arrayOf(breadcrumbsPropTypes).isRequired,
  loading: PropTypes.bool.isRequired,
  dispatchGetBusAssignmentSchedules: PropTypes.func.isRequired,
  dispatchClearBusAssignmentSchedules: PropTypes.func.isRequired,
  busAssignmentSchedules: PropTypes.instanceOf(Immutable.Map).isRequired,
  dispatchGetExportBusAssignmentSchedules: PropTypes.func.isRequired
};

const mapStateToProps = ({ BusUnit }) => ({
  breadcrumbs: [
    ...BusUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Asignación de Rutas',
      href: '',
    },
  ],
  busAssignmentSchedules: BusUnit.BusAssignmentSchedule.getIn([
    'all',
    'content',
  ]),
  loading: BusUnit.BusAssignmentSchedule.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetBusAssignmentSchedules: getBusAssignmentSchedules,
  dispatchClearBusAssignmentSchedules: clearBusAssignmentSchedules,
  dispatchGetExportBusAssignmentSchedules: getExportBusAssignmentSchedules
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BusAssignmentSchedules);
